import React from 'react';
import {Link} from "react-router-dom";

const LinkElement = (props) => {
    const url = props.to;
    if (url.startsWith("http")) {
        return (
            <a href={url} {...props} >
                {props.children}
            </a>
        );
    }
    else {
        return (
            <Link {...props}  >
                {props.children}
            </Link>
        );
    }
}

export default LinkElement;

